import { render, staticRenderFns } from "./BlankSidebarContent.vue?vue&type=template&id=0ec3f37a&"
import script from "./BlankSidebarContent.vue?vue&type=script&lang=ts&"
export * from "./BlankSidebarContent.vue?vue&type=script&lang=ts&"
import style0 from "./BlankSidebarContent.vue?vue&type=style&index=0&id=0ec3f37a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports